import { subDays } from 'date-fns';

/** Returns new Date = now - N days (computed at call time). */
export const getDaysAgoDate = (days: number): Date => subDays(new Date(), days);

export const oneDayAgo = getDaysAgoDate(1);
export const sevenDaysAgo = getDaysAgoDate(7);
export const fifteenDaysAgo = getDaysAgoDate(15);
export const thirtyDaysAgo = getDaysAgoDate(30);